import * as Images from './images';
import * as Gifs from './gifs';

export {
  Images,
  Gifs,
};
